const config = {
    baseUrl: '/freelancer-signup',
    apiRegistryUrl: '/api/profile/wizard/registry',
};

export {config};
